const fields = (items) => items;

const TITLE_POSITION_FIELD = {
  key: "titlePosition",
  label: "Title Position",
  value: "auto",
};

export const DASHBOARD_WIDGET_FONT_SIZES_UPDATED_EVENT = "dashboard-widget-font-sizes-updated";

let cachedDashboardWidgetFontSizes = null;

export const DASHBOARD_WIDGET_FONT_SIZE_FIELDS = [
  { type: "chart", label: "Chart", fields: fields([{ key: "labelFontSize", label: "Label", value: 12 }, { key: "valueFontSize", label: "Value", value: 18 }]) },
  { type: "period-column", label: "Period Column", fields: fields([{ key: "labelFontSize", label: "Label", value: 12 }, { key: "valueFontSize", label: "Value", value: 18 }]) },
  { type: "gauge", label: "Gauge", fields: fields([{ key: "labelFontSize", label: "Label", value: 14 }, { key: "valueFontSize", label: "Value", value: 24 }]) },
  { type: "radial-gauge", label: "Radial Gauge", fields: fields([{ key: "labelFontSize", label: "Label", value: 14 }, { key: "valueFontSize", label: "Value", value: 24 }]) },
  { type: "label", label: "Label", fields: fields([{ key: "labelFontSize", label: "Label", value: 14 }, { key: "valueFontSize", label: "Value", value: 24 }]) },
  { type: "led", label: "LED", fields: fields([{ key: "labelFontSize", label: "Label", value: 14 }, { key: "valueFontSize", label: "Value", value: 16 }]) },
  { type: "number", label: "Number", fields: fields([{ key: "labelFontSize", label: "Label", value: 14 }, { key: "valueFontSize", label: "Value", value: 18 }]) },
  { type: "slider", label: "Slider", fields: fields([{ key: "labelFontSize", label: "Label", value: 14 }, { key: "valueFontSize", label: "Value", value: 18 }]) },
  { type: "switch", label: "Switch", fields: fields([{ key: "labelFontSize", label: "Label", value: 14 }, { key: "switchSize", label: "Button Size", value: 28 }]) },
  { type: "push-button", label: "Push Button", fields: fields([{ key: "labelFontSize", label: "Title", value: 14 }, { key: "valueFontSize", label: "On/Off", value: 16 }, { key: "buttonSize", label: "Button Size", value: 16 }]) },
  { type: "terminal", label: "Terminal", fields: fields([{ key: "labelFontSize", label: "Label", value: 14 }, { key: "valueFontSize", label: "Value", value: 16 }]) },
  { type: "text", label: "Text", fields: fields([{ key: "labelFontSize", label: "Label", value: 14 }, { key: "valueFontSize", label: "Value", value: 16 }]) },
  { type: "menu", label: "Menu", fields: fields([{ key: "labelFontSize", label: "Label", value: 14 }, { key: "valueFontSize", label: "Value", value: 16 }]) },
  { type: "segment-switch", label: "Segment Switch", fields: fields([
    { key: "labelFontSize", label: "Label", value: 14 },
    { key: "valueFontSize", label: "Value", value: 16 },
    { key: "paddingLeft", label: "Padding Left", value: 8, min: 0, max: 200 },
    { key: "paddingRight", label: "Padding Right", value: 8, min: 0, max: 200 },
    { key: "paddingTop", label: "Padding Top", value: 8, min: 0, max: 200 },
    { key: "paddingBottom", label: "Padding Bottom", value: 8, min: 0, max: 200 },
  ]) },
  { type: "image-button", label: "Image Button", fields: fields([{ key: "labelFontSize", label: "Label", value: 14 }]) },
  { type: "keypad", label: "Keypad", fields: fields([{ key: "labelFontSize", label: "Label", value: 14 }, { key: "valueFontSize", label: "Input", value: 18 }, { key: "keyFontSize", label: "Keys", value: 18 }]) },
  { type: "table", label: "Table", fields: fields([{ key: "labelFontSize", label: "Label", value: 12 }, { key: "valueFontSize", label: "Value", value: 14 }]) },
  { type: "fan", label: "Fan", fields: fields([{ key: "labelFontSize", label: "Label", value: 14 }, { key: "valueFontSize", label: "Value", value: 16 }]) },
  { type: "pipe", label: "Pipe", fields: fields([{ key: "titleFontSize", label: "Title", value: 34 }, { key: "statusFontSize", label: "Status", value: 30 }]) },
  { type: "elbow", label: "Elbow", fields: fields([{ key: "titleFontSize", label: "Title", value: 34 }, { key: "statusFontSize", label: "Status", value: 30 }]) },
  { type: "water-pump", label: "Water Pump", fields: fields([{ key: "labelFontSize", label: "Label", value: 14 }]) },
  { type: "liquid", label: "Liquid", fields: fields([{ key: "labelFontSize", label: "Label", value: 14 }, { key: "valueFontSize", label: "Value", value: 24 }]) },
  { type: "water-tank", label: "Water Tank", fields: fields([{ key: "labelFontSize", label: "Label", value: 14 }, { key: "valueFontSize", label: "Value", value: 24 }]) },
  { type: "text-title", label: "Title Widget", fields: fields([{ key: "titleSize", label: "Title", value: 20 }]) },
  { type: "time-range", label: "Digital Clock", fields: fields([{ key: "titleSize", label: "Title", value: 20 }, { key: "valueSize", label: "Value", value: 64 }, { key: "dayLabelFontSize", label: "Days", value: 12 }]) },
  { type: "environmental-status", label: "Environmental Status", fields: fields([{ key: "titleSize", label: "Title", value: 20 }, { key: "datastreamTitleSize", label: "Datastream Title", value: 16 }, { key: "valueSize", label: "Value", value: 31 }]) },
  { type: "asset-status", label: "Asset Status", fields: fields([{ key: "titleFontSize", label: "Title", value: 14 }, { key: "assetNameFontSize", label: "Asset Name", value: 14 }, { key: "datastreamLabelFontSize", label: "Datastream Label", value: 14 }, { key: "valueFontSize", label: "Value", value: 16 }]) },
  { type: "status-arrow", label: "Status Arrow", fields: fields([{ key: "strokeWidth", label: "Stroke", value: 3 }, { key: "bend", label: "Bend", value: 50 }, { key: "dash", label: "Dash", value: "none" }]) },
].map((widget) => (
  widget.type === "status-arrow"
    ? widget
    : { ...widget, fields: [...widget.fields, { ...TITLE_POSITION_FIELD }] }
));

const clampFontSize = (value, fallback) => {
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return fallback;
  return Math.min(80, Math.max(8, Math.round(parsed)));
};

const clampWidgetNumber = (value, fallback, { min = 0, max = 100 } = {}) => {
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return fallback;
  return Math.min(max, Math.max(min, Math.round(parsed)));
};

const normalizeDashValue = (value, fallback = "none") => {
  const normalized = String(value || "").trim().toLowerCase();
  return ["none", "dashed", "dotted"].includes(normalized) ? normalized : fallback;
};

const normalizeTitlePosition = (value, fallback = "auto") => {
  const normalized = String(value || "").trim().toLowerCase();
  return ["auto", "left", "center", "right"].includes(normalized) ? normalized : fallback;
};

export const DEFAULT_DASHBOARD_WIDGET_FONT_SIZES = {
  widgets: DASHBOARD_WIDGET_FONT_SIZE_FIELDS.reduce((acc, field) => {
    acc[field.type] = {
      ...field.fields.reduce((fieldAcc, item) => {
        fieldAcc[item.key] = item.value;
        return fieldAcc;
      }, {}),
    };
    return acc;
  }, {}),
};

export const normalizeDashboardWidgetFontSizes = (value = {}) => {
  const source = value && typeof value === "object" ? value : {};
  const sourceWidgets = source.widgets && typeof source.widgets === "object" ? source.widgets : source;

  return {
    widgets: DASHBOARD_WIDGET_FONT_SIZE_FIELDS.reduce((acc, field) => {
      const widget = sourceWidgets?.[field.type] || {};
      acc[field.type] = field.fields.reduce((fieldAcc, item) => {
        let legacyValue = widget[item.key];
        if (field.type === "push-button" && item.key === "buttonSize") {
          legacyValue = widget.buttonSize ?? widget.valueFontSize;
        } else if (field.type === "switch" && item.key === "switchSize") {
          legacyValue = widget.switchSize ?? widget.valueFontSize;
        } else if (field.type === "keypad" && item.key === "keyFontSize") {
          legacyValue = widget.keyFontSize ?? widget.valueFontSize;
        } else if (field.type === "elbow" && item.key === "titleFontSize") {
          legacyValue = widget.titleFontSize ?? widget.labelFontSize;
        } else if (field.type === "elbow" && item.key === "statusFontSize") {
          legacyValue = widget.statusFontSize ?? widget.valueFontSize;
        } else if (
          item.key === "titleFontSize" ||
          item.key === "assetNameFontSize" ||
          item.key === "datastreamLabelFontSize"
        ) {
          legacyValue = widget[item.key] ?? widget.labelFontSize;
        }
        if (item.key === "titlePosition") {
          fieldAcc[item.key] = normalizeTitlePosition(legacyValue, item.value);
        } else if (field.type === "status-arrow" && item.key === "dash") {
          fieldAcc[item.key] = normalizeDashValue(legacyValue, item.value);
        } else if (field.type === "status-arrow" && item.key === "strokeWidth") {
          fieldAcc[item.key] = clampWidgetNumber(legacyValue, item.value, { min: 1, max: 18 });
        } else if (field.type === "status-arrow" && item.key === "bend") {
          fieldAcc[item.key] = clampWidgetNumber(legacyValue, item.value, { min: 0, max: 100 });
        } else if (["paddingLeft", "paddingRight", "paddingTop", "paddingBottom"].includes(item.key)) {
          fieldAcc[item.key] = clampWidgetNumber(legacyValue, item.value, { min: 0, max: 200 });
        } else if (item.key === "buttonSize" || item.key === "switchSize") {
          fieldAcc[item.key] = clampWidgetNumber(legacyValue, item.value, { min: 8, max: 160 });
        } else {
          fieldAcc[item.key] = clampFontSize(legacyValue, item.value);
        }
        return fieldAcc;
      }, {});
      return acc;
    }, {}),
  };
};

export const getCachedDashboardWidgetFontSizes = () => cachedDashboardWidgetFontSizes;

export const setCachedDashboardWidgetFontSizes = (value = {}) => {
  cachedDashboardWidgetFontSizes = normalizeDashboardWidgetFontSizes(value);
  return cachedDashboardWidgetFontSizes;
};

export const notifyDashboardWidgetFontSizesUpdated = (value = {}) => {
  const nextConfig = setCachedDashboardWidgetFontSizes(value);

  if (typeof window !== "undefined" && typeof window.dispatchEvent === "function") {
    window.dispatchEvent(new CustomEvent(DASHBOARD_WIDGET_FONT_SIZES_UPDATED_EVENT, {
      detail: nextConfig,
    }));
  }

  return nextConfig;
};
